import React from 'react';

import { useAttachments } from 'scenes/Gallery/GalleryPage/Concepts/data';
import Attachments from 'scenes/Gallery/components/Attachments';

const AttachmentsTab = ({ conceptId }) => {
  const { data, isLoading, isRefetching } = useAttachments({ id: conceptId });

  return (
    <Attachments
      data={data}
      isLoading={isLoading}
      isRefetching={isRefetching}
      dense={false}
    />
  );
};

export default AttachmentsTab;
